'use client';

import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import Button from '@alltrails/denali/components/Button';
import styles from './ShowMoreButton.module.scss';

type Props = {
  isExpanded: boolean;
  onToggle: () => void;
  testId?: string;
  className?: string;
  showMoreText?: React.ReactNode;
  showLessText?: React.ReactNode;
};

export default function ShowMoreButton({
  isExpanded,
  onToggle,
  testId = 'show-more-button',
  className,
  showMoreText = <FormattedMessage defaultMessage="Show more" />,
  showLessText = <FormattedMessage defaultMessage="Show less" />
}: Props) {
  return (
    <Button
      className={classNames(styles.showMoreButton, className)}
      onClick={onToggle}
      testId={testId}
      text={isExpanded ? showLessText : showMoreText}
      variant="default"
      width="fullOnMobile"
    />
  );
}
